import styled from 'styled-components';
import { COLORS, BREAKPOINTS, SPACING } from '../../style';

export const Row = styled.footer`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SPACING.lg};
  justify-content: space-between;
  padding: ${SPACING.lg} ${SPACING.md};
  background: ${COLORS.grey};
  color: ${COLORS.white};
  width: 100%;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    grid-template-columns: 1fr;
  }

  div {
    text-align: center;
    display: inline-flex;
    align-items: center;
    flex-direction: column;

    a {
      display: inline-flex;
      align-items: center;
      margin-bottom: ${SPACING.xs};
      cursor: pointer;
      color: ${COLORS.white};

      svg {
        margin-right: ${SPACING.xs};
      }

      &:hover {
        color: ${COLORS.blue};
      }
    }

    img {
      width: 40px;
      margin-bottom: ${SPACING.xs};
    }

    h3 {
      margin-bottom: ${SPACING.sm};
    }
  }
`;

export const Final = styled.div`
  background: ${COLORS.grey};
  color: ${COLORS.white};
  text-align: center;
  padding-bottom: ${SPACING.md};

  p {
    margin-bottom: ${SPACING.xs};
  }

  a {
    cursor: pointer;
    color: ${COLORS.white};

    &:hover {
      color: ${COLORS.blue};
    }
  }
`;